import React from 'react';
import packageJson from '../../package.json';

export const AppVersion: React.FC = () => {
    return (
        <div style={{ fontSize: 12, color: '#888' }}>
    Verze aplikace: {packageJson.version}
    </div>
);
};
